
const configuration = {
    default_port: 3088,
    database: {
        url: 'mongodb://easy:Cobi2015@localhost:27017/byppay'
    },
    URL_NODE: 'https://node-teranyina.centreeasy.com/',
    walletMoneder: {
        address: '0x282907027C6BB72a9eAAB32E1c225C628e037a53',
        privateKey: '6b6bca3169cd2adea68aac8edb50d03107f243beb2a6b4e997d0aa9fbfa05c2a',
        // address: '0x264e90f629Fe6938aEc280c47E1a093dBd6e5A80',
        // privateKey: 'ef2190ef98a2691109697ff3512e8eb333210bd07ce855087b3743d6acc8e435',
    },

    stripe: {
        //private_key: "sk_test_51HPNIaJmvzOT41paF3snKtKxHnaJTPKvrlwtW1g08f5PGsDm5M4PHx95jVLiNhX0pOiy8chrINsA2SJMQ8r4Cx4Z00NRqrhvTu"
        public_key: "pk_test_51I6uGRAH1lmR0otDuX7uwauP35GR8b4GtHM4wLvSQl6LqGMosOdPwvA3rx7m8VgH6R8hjX8O4p6kepYwnbAcWCG800SUtX8lK8",
        private_key: "sk_test_51I6uGRAH1lmR0otDS04nLHP9TQX6GF78KQt8ZfvknQqH3ZtCNx7zVyLkvWuKNDsT9Irg6XdRFqeIoWTCVHa3zOgT0052UVglmT"
    },
    genesisLiquidity: 200000000,
    wallets: {
        dao: {
            wallet: "0x264e90f629Fe6938aEc280c47E1a093dBd6e5A80",
            percentage: 15
        },
        foundersAndInvestors: {
            wallet: "0x56F1FdBa80A7f3Be0ed5F91507131817caC66002",
            percentage: 15
        },
        Marketing: {
            wallet: "0x282907027C6BB72a9eAAB32E1c225C628e037a53",
            percentage: 25
        },
        ManagementTeam: {
            wallet: "0xC637f963b5D6Ca8be738028BB49630f81BA97715",
            percentage: 5
        },
        Liquidity: {
            wallet: "0x77DEc403304679a3Dd534e40729AE378a2FC6f30",
            percentage: 20
        },
        StakingRewards: {
            wallet: "0x2565E1b49B778F91B8b1cB959e115efbF77DAe7a",
            percentage: 10
        },
        Raffles: {
            wallet: "0xA9DA4B1845A4A5f7C3e9369d4CC8Fa43Ef743Bb1",
            percentage: 10
        },
    }
};

// Export configuration
module.exports = configuration;
